var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0v30H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 15 12.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#DD544A",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.383 4.323 4.784 4.679a1.09 1.09 0 0 1 0 1.56 1.14 1.14 0 0 1-1.595 0l-2.947-2.883v13.194a1.127 1.127 0 0 1-2.255 0V7.678L8.423 10.56a1.14 1.14 0 0 1-1.595 0 1.09 1.09 0 0 1 0-1.56l4.784-4.678c.244-.24.57-.347.886-.322.316-.025.641.083.885.322z",
    fill: "#FFF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-exit.707f2c631c879428696ac3ad16481c55.svg";